import CoursesFilter from './CoursesFilter';

export default CoursesFilter;
